import produce from "immer";
import { create } from "zustand";

export const useToastGlobal = create((set) => ({
    visible: false,
    level: "success",
    content: "",
    actions: [],
    auto_hide_timeout: 3000,
    dismissible: false,
    onChangeStatus: () => {
        set(
            produce((state) => {
                state.visible = false;
                state.actions = [];
                state.auto_hide_timeout = 3000;
                state.dismissible = false;
            })
        );
    },
    setShow: (json) => {
        set(
            produce((state) => {
                state.visible = json.visible;
                state.content = json.content;
                state.level = json.level;
                state.actions = json.actions ?? [];
                state.auto_hide_timeout = json.auto_hide_timeout ?? 3000;
                state.dismissible = json.dismissible ?? false;
            })
        );
    },
}));
